import React from 'react'
import './footer.css'
import { Link } from 'react-router-dom'
export default function footer() {
  return (
    <div className='footer'>
      {/*container 1*/}
      <div className='c1'>
        <h1>Menu</h1>
        <p><Link to='/' style={{textDecoration:'none',color:'white'}}>Home</Link></p>
        <p><Link to='/about' style={{textDecoration:'none',color:'white'}}>About</Link></p>
        <p><Link to='/cont' style={{textDecoration:'none',color:'white'}}>Contact</Link></p>
        <p><Link to='/services' style={{textDecoration:'none',color:'white'}}>Services</Link></p>
      </div>

      {/*contanier 2*/}
      <div className='c1'>
        <h1>Contact Our</h1>
        <p><Link to='/chat' style={{textDecoration:'none',color:'white'}}>Chat with us Customer Services</Link></p>    
        <p>Call to Customer:8121005746 </p>
      </div>

      {/*address*/}
      <div className='c1'>
        <h1>Address</h1>
        <p>Head office</p>
        <p><a  style={{textDecoration:'none',color:'white'}} href='https://maps.app.goo.gl/7YSSR65GNK5xzp928'>2nd Floor, 3-5-239/52, Krishna Nagar, Moula Ali, Secunderabad, Telangana 500040</a></p>
        <p>Branch Office</p>
        <p><a style={{textDecoration:'none',color:'white'}} href='https://maps.app.goo.gl/jBDzuGj8tTf2RjTM7'>8FM4+8VQ, opposite Bhashyam Aditya CO Campus, Guntur, Andhra Pradesh 522034</a></p>
      </div>

      {/*social*/}
      <div className='c1'>
        <h1>Social</h1>
        <p><a style={{textDecoration:'none',color:'white'}}href='https://www.instagram.com/accounts/login/?hl=en'>Instagram</a></p>
        <p><a  style={{textDecoration:'none',color:'white'}} href='https://www.facebook.com/'>Facebook</a></p>
        <p><a  style={{textDecoration:'none',color:'white'}} href='https://www.youtube.com/@samrajindustries2263'>Youtube</a></p>
        <p><a style={{textDecoration:'none',color:'white'}} href='https://www.linkedin.com/company/samraj-solar-energies/mycompany/'>LinkedIn</a></p>
        <p style={{fontSize:'15px',marginTop:'150px'}}><a style={{textDecoration:'none',color:'white'}} href='https://coral-leah-43.tiiny.site/'>Developed by :Murali Karthik Rayavarapu</a></p>
      </div>
    </div>
  )
}
